import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

export default function (element, data) {
    const swiper = new Swiper(element.querySelector(".team-slider"), {
        modules: [Autoplay, Navigation],
        slidesPerView: 1,
        speed: 0,
        loop: true,
        spaceBetween: 30,
        simulateTouch: false, 
        allowTouchMove: false,
        autoplay: false,
        autoHeight: true,
        navigation: {
            nextEl: element.querySelector(".swiper-button-next"),
            prevEl: element.querySelector(".swiper-button-prev"),
        }
    });

    function goToSlideById(slideId) {
        const slides = swiper.slides;
        const index = Array.from(slides).findIndex(
            slide => slide.dataset.team_id === slideId
        );

        if (index !== -1) {
            swiper.slideToLoop(index);
        }
    }

    window.addEventListener("open-popup-team", function (e) {
        let itemData = e.detail.dataset;
        
        if (itemData.team_id) {
            goToSlideById(itemData.team_id);
        }
        
        // setTimeout(() => {
            element.classList.add("open");
            document.body.classList.add('no-scroll');
        // }, 500);
    });
    window.addEventListener("close-popup-team", function () {
        element.classList.remove("open");
        document.body.classList.remove('no-scroll');
    });
    element.addEventListener("click", function (event) {
        window.dispatchEvent(new CustomEvent('close-popup-team'));
    });
    element.querySelector(".team__popup_block").addEventListener("click", function (event) {
        event.stopPropagation();
    });
}
